// extracted by mini-css-extract-plugin
export var heading = "index-module--heading--d5e13";
export var headingContainer = "index-module--heading-container--9c37d";
export var highlight = "index-module--highlight--bfbb3";
export var highlightLine = "index-module--highlight-line--4e706";
export var image1 = "index-module--image-1--ca8cf";
export var image2 = "index-module--image-2--4a67d";
export var imageContainer = "index-module--image-container--f7c64";